import { render, staticRenderFns } from "./fullgame.vue?vue&type=template&id=470ec430&scoped=true&"
import script from "./fullgame.vue?vue&type=script&lang=js&"
export * from "./fullgame.vue?vue&type=script&lang=js&"
import style0 from "./fullgame.vue?vue&type=style&index=0&id=470ec430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470ec430",
  null
  
)

export default component.exports